import { Injectable } from '@angular/core';
import { SystemPermission, SystemPermissions } from '@app/interfaces';
import { ApiRequestService } from '@app/core/http/api-request.service';
import { UserDetailsService } from '@app/shared/services/user-details/user-details.service';
import { Observable, of, Subject } from 'rxjs';
import { catchError, map, take } from 'rxjs/operators';
import { PermissionsService as BasePermissionsService } from '@afaqyit/frontend-core';

@Injectable({
  providedIn: 'root',
})
export class PermissionsService extends BasePermissionsService {
  public refresh: Subject<any> = new Subject();
  public permissionsUpdated: Subject<any> = new Subject();
  public permissions: SystemPermissions | boolean;
  isAdmin: boolean = false;

  constructor(
    protected apiRequestService: ApiRequestService,
    protected userDetailsService: UserDetailsService,
  ) {
    // Please fill the super() call by the needed parameters
    super(apiRequestService, userDetailsService);
  }

  /**
   * helper function for easier mapping in template for better performance on the dom
   * and not using getPermissions directly in templating
   * @param module: module permissions key
   */
  public getPermissionsHelper(module?: string): SystemPermission {
    const helperPermissions: SystemPermission = {};
    helperPermissions.all = this.booleanPermissionsChecker(module);
    if (this.getPermissions(module)) {
      if (typeof this.permissions[module] === 'object') {
        if (Object.keys(this.permissions[module]).length) {
          Object.keys(this.permissions[module]).forEach((key) => {
            helperPermissions[key] = this.booleanPermissionsChecker(module, key);
          });
        }
      }
    }
    return helperPermissions;
  }

  /**
   * helper function to return permissions as boolean only
   * @param module: module permission key
   * @param key: sub module permissions key
   */
  public booleanPermissionsChecker(module?: string, key?: string): boolean {
    if (module) {
      if (key) {
        return !!this.getPermissions(module, key);
      } else {
        if (typeof this.getPermissions(module) === 'boolean') {
          return !!this.getPermissions(module);
        } else {
          return false;
        }
      }
    } else {
      return true;
    }
  }

  /**
   * for any section in system to check for specific permission with module and key both optional,
   * or to return the full permissions of system
   * @param module: module permission key
   * @param key: sub module permissions key
   */
  // public getPermissions(module?: string, key?: string): boolean | SystemPermissions {
  //   if (this.permissions) {
  //     if (typeof this.permissions === 'boolean') {
  //       return this.permissions;
  //     } else {
  //       if (module) {
  //         if (this.permissions[module]) {
  //           if (typeof this.permissions[module] === 'boolean') {
  //             return this.permissions[module];
  //           } else if (typeof this.permissions[module] === 'object') {
  //             if (key) {
  //               return !!this.permissions[module][key];
  //             } else {
  //               return this.permissions[module];
  //             }
  //           }
  //         } else if (this.permissions['admin']) {
  //           if (module === 'manageUsersRoles') {
  //             return this.permissions['manageUsersRoles'];
  //           } else {
  //             return true;
  //           }
  //         }
  //       } else {
  //         return this.permissions;
  //       }
  //     }
  //   } else {
  //     return false;
  //   }
  // }
  getPermissions(module?: string, key?: string): boolean {
    if (!module) return true;

    const modulePermissions = this.permissions?.[module];

    if (!modulePermissions) return false;

    if (!key) return true;

    return !!modulePermissions[key];
  }
  /**
   * Permissions Request Api function checks if there isn't loaded permissions then request the api and then
   * call a callback function provided with the request as optional
   * @param options : {
   *        getPermissions: optional callback function to be executed on successful api response or if permissions
   *        already exist on service, should be the same getPermissions function with module and key
   *        if they are provided. unless another logic is needed,
   *        refresh: if needed to force refresh permissions with an API request
   * }
   */

  /**
   * public method to update Private Permissions object with in the service
   * @param permissions : permissions data to be set,
   * if not provided then the function clears the permissions and set it to undefined
   */
  public setPermissions(permissions?: SystemPermissions | boolean) {
    this.permissions = permissions;
  }

  /**
   * refactor logic for permissions response
   * @param data : response data to parse
   */
  refactorPermissions(data: any): SystemPermissions | boolean {
    let permissions: SystemPermissions | boolean = false;
    // if (data) {
    // if (data.permissions) {
    // permissions = { ...data.permissions };
    // if (data.position === 'administrator') {
    //   permissions['admin'] = true;
    //   if (data.manageUsers) {
    //     permissions['manageUsersRoles'] = true;
    //   }
    // } else if (data.position === 'owner') {
    permissions = true;
    // }
    // }
    // }
    return permissions;
  }

  /**
   * refactor logic for user data response
   * @param data : response data to parse
   */
  refactorUserData(data: any) {
    if (data) {
      const userDetails = { ...data };
      delete userDetails.permissions;
      return userDetails;
    }
  }

  convertPermissions(permissions: string[]) {
    const result: Record<string, Record<string, boolean>> = {};

    permissions.forEach((permission) => {
      const parts = permission.split('-');

      const action = parts[0];
      const resource = parts[parts.length - 1];
      if (!result[resource]) {
        result[resource] = {};
      }

      result[resource][action] = true;
    });

    return (this.permissions = result);
  }
}
